import styled from "styled-components";
import { colors } from "../../../lib/colors";

export const ScrollHostContainer = styled.div`
  position: relative;
  width: 100%;
  display: -webkit-box;
  justify-content: flex-start;
  scroll-behavior: auto;
  margin-bottom: 19px;
  .scroll-host {
    overflow: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    position: relative;
    width: 100%;
    display: -webkit-box;
    justify-content: flex-start;
    padding: 15px 0;
  }
  .scroll-host::-webkit-scrollbar {
    display: none;
  }
  .scroll-bar {
    width: 100%;
    height: 6px;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
    height: 6px;
    border-radius: 3px;
    bottom: -6px;
    position: absolute;
  }
  .scroll-thumb {
    width: 50px;
    height: 6px;
    transition: width 0.5s;
    position: absolute;
    border-radius: 3px;
    opacity: 1;
    bottom: 0px;
    background-color: ${colors.secondary};
  }
`;
